/**
 * Device detection — PWA-ready module.
 *
 * Single source of truth for "should we open the camera UI" vs
 * "should we show the desktop handoff screen".
 *
 * Used by BOSCO Capture (Phase 1+) but generic enough to reuse
 * elsewhere if we ever ship other camera-first features.
 */

export function detectDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return { kind: 'desktop', isMobile: false, isTouch: false, ua: '' };
  }
  const ua = navigator.userAgent || '';
  const lowered = ua.toLowerCase();

  const isiPhone = /iphone|ipod/i.test(ua);
  const isiPad = /ipad/i.test(ua) || (lowered.includes('mac') && navigator.maxTouchPoints > 1);
  const isAndroid = /android/i.test(ua) && !/tablet/i.test(ua) && lowered.includes('mobile');
  const isAndroidTablet = /android/i.test(ua) && !lowered.includes('mobile');
  const isMobileUA = /mobi|iphone|ipod|android.+mobile|windows phone/i.test(ua);
  const isTouch = (navigator.maxTouchPoints || 0) > 0;
  const isMobile = isiPhone || isAndroid || isMobileUA;

  let kind = 'desktop';
  if (isiPhone) kind = 'iphone';
  else if (isAndroid) kind = 'android';
  else if (isiPad) kind = 'ipad';
  else if (isAndroidTablet) kind = 'android-tablet';
  else if (isMobile) kind = 'mobile';

  return {
    kind,                  // 'iphone' | 'android' | 'ipad' | 'android-tablet' | 'mobile' | 'desktop'
    isMobile,              // true when camera UI should open directly
    isTablet: isiPad || isAndroidTablet,
    isTouch,
    ua,
  };
}

export function isCameraReady() {
  return typeof navigator !== 'undefined'
    && !!navigator.mediaDevices
    && typeof navigator.mediaDevices.getUserMedia === 'function'
    && (typeof window !== 'undefined' ? window.isSecureContext : false);
}
